var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_7077)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73532 3.73556C5.91907 1.55365 9.06907 0.463623 12.9341 0.463623C16.799 0.463623 19.949 1.55365 22.1328 3.73556C24.3166 5.91747 25.4047 9.06931 25.4047 12.9343C25.4047 16.7993 24.3147 19.9493 22.1328 22.133C19.9509 24.3168 16.799 25.405 12.9341 25.405C9.06907 25.405 5.91907 24.315 3.73532 22.133C1.55156 19.9511 0.463379 16.7993 0.463379 12.9343C0.463379 9.06931 1.55341 5.91931 3.73532 3.73556ZM19.6793 8.38574C19.6381 7.80941 19.3905 7.26725 18.982 6.85868C18.5734 6.45012 18.0312 6.20254 17.4549 6.16134C14.68 5.95811 9.87643 6.52345 5.16529 10.5178C4.01059 11.4969 3.92191 13.3223 5.21702 14.3052C5.99667 14.9019 7.05344 15.567 8.2303 15.9771L12.1452 12.0623C12.3617 11.8457 12.6555 11.724 12.9618 11.724C13.2681 11.724 13.5618 11.8457 13.7784 12.0623C13.9949 12.2789 14.1166 12.5726 14.1166 12.8789C14.1166 13.1852 13.9949 13.4789 13.7784 13.6955L9.8635 17.6103C10.2736 18.7872 10.9387 19.8421 11.5336 20.6236C12.5184 21.9169 14.3419 21.8282 15.321 20.6754C19.3154 15.9642 19.8825 11.1607 19.6793 8.38574Z",
    fill: "currentColor",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_7077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8651,
    height: 25.8651,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendCircle);
export default __webpack_public_path__ + "static/media/send_circle.aeda3ac2571ff6876f81ee8f6b1a309c.svg";
export { ForwardRef as ReactComponent };